import { render, staticRenderFns } from "./new_trusteeship.vue?vue&type=template&id=f81b9d28&scoped=true&"
import script from "./new_trusteeship.vue?vue&type=script&lang=js&"
export * from "./new_trusteeship.vue?vue&type=script&lang=js&"
import style0 from "./new_trusteeship.vue?vue&type=style&index=0&id=f81b9d28&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81b9d28",
  null
  
)

export default component.exports